module.exports = __webpack_public_path__ + "img/pm2.5.e33ea55d.svg";